package com.appsyde.shared.modules.account.domain.usecase

import com.appsyde.shared.modules.account.domain.repository.AccountRepository

class CompleteOnboardingUseCase(
    private val accountRepository: AccountRepository
) {
    suspend operator fun invoke(): Boolean = accountRepository.completeOnboarding()
}
